import type { PriceComponentsProps } from '../../../types';
import { ActualPrice, ThenPrice, WasPrice } from './PriceComponents.styles';

export function WasPriceComponent({ price }: PriceComponentsProps) {
  return (
    <>
      <span id="wasPriceDesc" className="visually-hidden">
        The original price was {price}
      </span>
      <WasPrice aria-describedby="wasPriceDesc" data-testid="wasPrice">
        {price}
      </WasPrice>
    </>
  );
}

export function ThenPriceComponent({ price }: PriceComponentsProps) {
  return (
    <>
      <span id="thenPriceDesc" className="visually-hidden">
        then reduced to ${price}
      </span>
      <ThenPrice aria-describedby="thenPriceDesc" data-testid="thenPrice">
        {price}
      </ThenPrice>
    </>
  );
}

export function ActualPriceComponent({ price, isDiscounted }: PriceComponentsProps) {
  return (
    <>
      <span id="actualPriceDesc" className="visually-hidden">
        {isDiscounted ? `and now it's ${price}` : price}
      </span>
      <ActualPrice aria-describedby="actualPriceDesc" data-testid="actualPrice">
        {price}
      </ActualPrice>
    </>
  );
}
